/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * NOT_EQUAL operator looks for values that are not equal to the given value.
 */
export interface NotEqualKeyPublicBase58 {
    /** The value to compare against. */
    value: string;
}
